// Per .cursor/rules/main.mdc: never send PII to Sentry. URLs in this app can
// carry email, invitation tokens, and other-user contractUids in query strings
// and referrers, so we allow-list the keys we want to forward and strip query
// + hash from the referrer.
const SEARCH_PARAM_ALLOWLIST = new Set(['year_month', 'mode'])

let authReadyAt: number | null = null

export function markAuthReady(): void {
  if (authReadyAt === null) {
    authReadyAt = Date.now()
  }
}

function sanitizeSearch(rawSearch: string): string {
  const params = new URLSearchParams(rawSearch)
  const kept = new URLSearchParams()
  for (const [key, value] of params) {
    if (SEARCH_PARAM_ALLOWLIST.has(key)) kept.set(key, value)
  }
  const serialized = kept.toString()
  return serialized ? `?${serialized}` : ''
}

function sanitizeReferrer(rawReferrer: string): string | undefined {
  if (!rawReferrer) return undefined
  try {
    const u = new URL(rawReferrer)
    return `${u.origin}${u.pathname}`
  } catch {
    return undefined
  }
}

export function getIncompleteKeyExtras(): Record<string, unknown> {
  return {
    url_search:
      typeof window !== 'undefined'
        ? sanitizeSearch(window.location.search)
        : undefined,
    url_pathname:
      typeof window !== 'undefined' ? window.location.pathname : undefined,
    referrer:
      typeof document !== 'undefined'
        ? sanitizeReferrer(document.referrer)
        : undefined,
    ms_since_auth_ready: authReadyAt === null ? null : Date.now() - authReadyAt,
  }
}
